import * as process from "process";
import { createContext, useState, useEffect } from "react";
import Web3 from "web3";
import { ABI } from "../utils/abi";
import axios from "axios";
import { formatTimeStamp, numberWithCommas } from "../utils/util";
import { toast } from "react-toastify";
import ToastMsg from "../components/ToastMsg";
import { useAccount, useNetwork } from "wagmi";
import { providers } from "../utils/Web3Provider";
import Web3Modal from "web3modal";
const BlockchainContext = createContext({
  notification: null,
  showModal: function () {},
  hideModal: function () {},
});

const networkData = [
  {
    chainId: "0x89",
    chainName: "MATIC",
    rpcUrls: [
      "https://polygon-mainnet.infura.io/v3/c603ca5f9a154ea09e0c7793d5bcb726",
    ],
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    blockExplorerUrls: ["https://polygonscan.com/"],
  },
];

export const BlockchainContextProvider = (props) => {
  const { address, isConnected, connector } = useAccount();
  const { chain } = useNetwork();

  const [provider, setProvider] = useState();
  const [web3Instance, setWeb3Instance] = useState();
  const [web3Modal, setWeb3Modal] = useState();
  const [Contract, setContract] = useState();
  const [account, setAccount] = useState();
  const [startTime, setStartTime] = useState();
  const [usdPrice, setUsdPrice] = useState(0);
  const [totalDeposit, setTotalDeposit] = useState("0000.000");
  const [totalRefEarn, setRefEarn] = useState("0000.000");
  const [walletBalance, setWalletBalance] = useState("0.00000");
  const [harvestValue, setHarvestValue] = useState("0.00000");
  const [availableValue, setAvailableValue] = useState("0.00000");
  const [lastDepositValue, setLastDepositValue] = useState("0.00000");
  const [historyTotalInfo, setHistoryTotalInfo] = useState(["0.000", "0.000"]);
  const [userTransactions, setUserTransactions] = useState([]);
  const [userInvitedInfo, setUserInvitedInfo] = useState(["0", "0"]);
  const [insuranceInfo, setInsuranceInfo] = useState(["0"]);
  const [availableRefInfo, setAvailableRefInfo] = useState(["0"]);
  const [userTotalDeposits, setUserTotalDeposit] = useState();
  const [interv, setInterv] = useState();
  const [ischange, setIschange] = useState(true);
  var interva;

  const load = async () => {
    if (localStorage.getItem("siteInfo")) {
      setTotalDeposit(JSON.parse(localStorage.getItem("siteInfo"))[0]);
      setRefEarn(JSON.parse(localStorage.getItem("siteInfo"))[1]);
      if (localStorage.getItem("usdPrice")) {
        setUsdPrice(JSON.parse(localStorage.getItem("usdPrice")));
      }
    }

    if (address && isConnected && chain && connector) {
      if (chain.id !== 137) {
        try {
          const result = await connector.switchChain(137);
          if (result) {
            connectToWallet("wallet");
          }
        } catch (error) {
          // console.log(error);
          const result = await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: networkData,
          });

          if (result) {
            connectToWallet("wallet");
          }
        }
      } else {
        connectToWallet("wallet");
      }
    } else {
      connectToWallet("noWallet");
    }
  };

  // useEffect(() => {
  //   load();
  // }, [address, isConnected, chain, connector]);

  useEffect(() => {
    if (
      provider &&
      account &&
      web3Instance.currentProvider.isMetaMask === true &&
      ischange
    ) {
      setIschange(false);
      provider.on("accountsChanged", (accounts) => {
        setUserTransactions([]);
        setUserTransactions([]);
        setUserTotalDeposit(0);
        fetchImportantData(Contract, web3Instance, accounts[0]);
      });
    }
    if (
      provider &&
      account &&
      web3Instance.currentProvider.isMetaMask === true &&
      ischange
    ) {
      setIschange(false);
      provider.on("networkChanged", (networkId) => {
        setUserTransactions([]);
        setAccount("");
        setHarvestValue("");
        setWalletBalance("");
        connectToWallet();
      });
    }
  });

  useEffect(() => {
    if (localStorage.getItem("siteInfo")) {
      setTotalDeposit(JSON.parse(localStorage.getItem("siteInfo"))[0]);
      setRefEarn(JSON.parse(localStorage.getItem("siteInfo"))[1]);
      if (localStorage.getItem("usdPrice")) {
        setUsdPrice(JSON.parse(localStorage.getItem("usdPrice")));
      }
    }

    if (
      localStorage.getItem("account") &&
      localStorage.getItem("account") !== "undefined"
    ) {
      connectToWallet("wallet");
    } else {
      connectToWallet("noWallet");
    }
  }, [localStorage]);

  const fetchImportantData = async (contract, web3, account) => {
    try {
      if (account) {
        await contract.methods
          .getUserAvailable(account)
          .call((error, result) => {
            if (!error) {
              setHarvestValue(web3.utils.fromWei(result));
            }
          });
        await contract.methods.available(account).call((error, result) => {
          if (!error) {
            setAvailableValue(web3.utils.fromWei(result));
          }
        });
        await contract.methods.last_deposit(account).call((error, result) => {
          if (!error) {
            setLastDepositValue(web3.utils.fromWei(result));
          }
        });
        await contract.methods
          .getUserDepositInfo(account)
          .call((error, result) => {
            if (!error) {
              setStartTime(result);
            }
          });
        const WalletBl = await web3.eth.getBalance(account);
        console.log("Wallet Bl: " + WalletBl);
        setWalletBalance(web3.utils.fromWei(WalletBl));
        await contract.methods
          .getUserTotalReferrals(account)
          .call(async (error, totalRef) => {
            if (!error) {
              await contract.methods
                .getUserReferralTotalBonus(account)
                .call((error, refBonus) => {
                  if (!error) {
                    setUserInvitedInfo([
                      totalRef,
                      web3.utils.fromWei(refBonus),
                    ]);
                  }
                });
            }
          });
        await contract.methods
          .getUserAmountOfDeposits(account)
          .call((error, result) => {
            if (!error) {
              setUserTotalDeposit(web3.utils.fromWei(result));
            }
          });
        await contract.methods.last_deposit(account).call((error, result) => {
          if (!error) {
            setLastDepositValue(web3.utils.fromWei(result));
          }
        });
        setAccount(account);
        await contract.methods.insurance(account).call((error, result) => {
          if (!error) {
            setInsuranceInfo(result);
          }
        });
        setWalletBalance(web3.utils.fromWei(WalletBl));
        getUserTransactions(contract, account, web3);
      } else {
        localStorage.removeItem("account");
        setAccount("");
      }
      if (contract) {
        await contract.methods.getSiteInfo().call((error, result) => {
          if (!error) {
            setTotalDeposit(web3.utils.fromWei(result[0]));
            setRefEarn(web3.utils.fromWei(result[1]));
            localStorage.setItem(
              "siteInfo",
              JSON.stringify([
                web3.utils.fromWei(result[0]),
                web3.utils.fromWei(result[1]),
              ])
            );
          }
        });
      }
    } catch (error) {}
  };
  const getRealTimeData = async (contract, web3) => {
    try {
      interva = setInterval(async () => {
        const account = await web3.eth.getAccounts();
        if (account[0]) {
          await contract.methods
            .getUserAvailable(account[0])
            .call((error, result) => {
              if (!error) {
                setHarvestValue(web3.utils.fromWei(result));
              }
            });

          const WalletBl = await web3.eth.getBalance(account[0]);
          setWalletBalance(web3.utils.fromWei(WalletBl));

          await contract.methods
            .getUserTotalDeposits(account[0])
            .call(async (error, deposits) => {
              if (!error) {
                await contract.methods
                  .getUserTotalWithdrawn(account[0])
                  .call((error, Withdrawn) => {
                    if (!error) {
                      setHistoryTotalInfo([
                        web3.utils.fromWei(deposits),
                        web3.utils.fromWei(Withdrawn),
                      ]);
                    }
                  });
              }
            });
        } else {
          setHarvestValue("0");
          setWalletBalance("0");
        }
      }, 5000);
      setInterv(interva);
    } catch (error) {}
  };

  // const connectToWallet = async (type) => {
  //   try {
  //     if (type === "noWallet") {
  //       const web3 = new Web3(
  //         "https://polygon-mainnet.infura.io/v3/c603ca5f9a154ea09e0c7793d5bcb726"
  //       );
  //       const contractInstance = new web3.eth.Contract(
  //         ABI,
  //         "0x2ceaadeb52158c735789c00251505289a4b74c49"
  //       );
  //       setContract(contractInstance);
  //       setWeb3Instance(web3);
  //       setProvider(provider);
  //       fetchDataFromContract(contractInstance, web3, null);
  //     } else {
  //       const provider = await connector.getProvider();
  //       const web3 = new Web3(provider);
  //       const contractInstance = new web3.eth.Contract(
  //         ABI,
  //         "0x2ceaadeb52158c735789c00251505289a4b74c49"
  //       );
  //       setContract(contractInstance);
  //       setWeb3Instance(web3);
  //       setAccount(address);
  //       setProvider(provider);
  //       setWeb3Modal(web3Modal);
  //       fetchDataFromContract(contractInstance, web3, address);
  //       const wallet_bl = await web3.eth.getBalance(address);
  //       console.log("wallet bl: " + web3.utils.fromWei(wallet_bl));
  //       setWalletBalance(web3.utils.fromWei(wallet_bl));
  //     }
  //   } catch (error) {}
  // };

  const connectToWallet = async (type) => {
    if (type === "noWallet") {
      const web3 = new Web3(
        "https://polygon-mainnet.infura.io/v3/c603ca5f9a154ea09e0c7793d5bcb726"
      );
      const contractInstance = new web3.eth.Contract(
        ABI,
        "0x2ceaadeb52158c735789c00251505289a4b74c49"
      );
      console.log(process.env);
      setContract(contractInstance);
      setWeb3Instance(web3);
      setProvider(provider);
      fetchDataFromContract(contractInstance, web3, null);
    } else {
      try {
        const web3Modal = new Web3Modal({
          cacheProvider: true,
          providerOptions: providers,
          theme: "dark",
        });

        let provider;
        await web3Modal
          .connect(web3Modal)
          .then((res) => {
            provider = res;
          })
          .catch((err) => {
            provider =
              "https://polygon-mainnet.infura.io/v3/c603ca5f9a154ea09e0c7793d5bcb726";
          });

        const web3 = new Web3(provider);
        const account = await web3.eth.getAccounts();

        const contractInstance = new web3.eth.Contract(
          ABI,
          "0x2ceaadeb52158c735789c00251505289a4b74c49"
        );
        setContract(contractInstance);

        account.length > 0 && setAccount(account[0]);
        setWeb3Instance(web3);

        setProvider(provider);
        setWeb3Modal(web3Modal);
        fetchDataFromContract(contractInstance, web3, account[0]);
        console.log(account[0]);
        const wallet_bl = await web3.eth.getBalance(account[0]);
        console.log("wallet bl: " + web3.utils.fromWei(wallet_bl));
        setWalletBalance(web3.utils.fromWei(wallet_bl));
        localStorage.setItem("account", account[0]);
      } catch (error) {
        connectToWallet("noWallet");
      }
    }
  };

  const fetchDataFromContract = async (contract, web3, account) => {
    try {
      const newUsdPrice = await axios.get(
        "https://api.binance.us/api/v3/ticker/price?symbol=MATICUSDT"
      );

      console.log(newUsdPrice.data.price);

      setUsdPrice(newUsdPrice.data.price);
      if (contract && !account) {
        await contract.methods.getSiteInfo().call((error, result) => {
          if (!error) {
            setTotalDeposit(web3.utils.fromWei(result[0]));
            setRefEarn(web3.utils.fromWei(result[1]));
            localStorage.setItem(
              "siteInfo",
              JSON.stringify([
                web3.utils.fromWei(result[0]),
                web3.utils.fromWei(result[1]),
              ])
            );
            //localStorage.setItem("usdPrice", 0);
            localStorage.setItem("usdPrice", newUsdPrice.data.price);
          }
        });
      }
      if (contract && account) {
        await contract.methods.getSiteInfo().call((error, result) => {
          if (!error) {
            setTotalDeposit(web3.utils.fromWei(result[0]));
            setRefEarn(web3.utils.fromWei(result[1]));
            localStorage.setItem(
              "siteInfo",
              JSON.stringify([
                web3.utils.fromWei(result[0]),
                web3.utils.fromWei(result[1]),
              ])
            );
            localStorage.setItem("usdPrice", newUsdPrice.data.price);
          }
        });
        await contract.methods
          .getUserAvailable(account)
          .call((error, result) => {
            if (!error) {
              setHarvestValue(web3.utils.fromWei(result));
            }
          });
        await contract.methods.available(account).call((error, result) => {
          if (!error) {
            setAvailableValue(web3.utils.fromWei(result));
          }
        });
        await contract.methods
          .getUserDepositInfo(account)
          .call((error, result) => {
            if (!error) {
              setStartTime(result[3]);
            }
          });
        await contract.methods
          .getUserAmountOfDeposits(account)
          .call((error, result) => {
            if (!error) {
              setUserTotalDeposit(web3.utils.fromWei(result));
            }
          });
        await contract.methods.last_deposit(account).call((error, result) => {
          if (!error) {
            setLastDepositValue(web3.utils.fromWei(result));
          }
        });
        await contract.methods.insurance(account).call((error, result) => {
          if (!error) {
            setInsuranceInfo(result);
          }
        });
        await contract.methods
          .getUserReferralBonus(account)
          .call((error, result) => {
            if (!error) {
              setAvailableRefInfo(web3.utils.fromWei(result));
            }
          });
        await contract.methods
          .getUserTotalDeposits(account)
          .call(async (error, deposits) => {
            if (!error) {
              await contract.methods
                .getUserTotalWithdrawn(account)
                .call((error, Withdrawn) => {
                  if (!error) {
                    setHistoryTotalInfo([
                      web3.utils.fromWei(deposits),
                      web3.utils.fromWei(Withdrawn),
                    ]);
                  }
                });
            }
          });

        await contract.methods
          .getUserTotalReferrals(account)
          .call(async (error, totalRef) => {
            if (!error) {
              await contract.methods
                .getUserReferralTotalBonus(account)
                .call((error, refBonus) => {
                  if (!error) {
                    setUserInvitedInfo([
                      totalRef,
                      web3.utils.fromWei(refBonus),
                    ]);
                  }
                });
            }
          });
        getUserTransactions(contract, account, web3);

        getRealTimeData(contract, web3);
      }
    } catch (error) {}
  };

  const invest = async (amount) => {
    try {
      if (account) {
        let refAccount;
        if (localStorage.getItem("baseRef")) {
          refAccount = localStorage.getItem("baseRef");
          refAccount = refAccount.split("&");
          refAccount = refAccount[0];
        } else {
          refAccount = account;
        }

        await Contract.methods
          .invest(refAccount)
          .send(
            {
              from: account,
              value: web3Instance.utils.toWei(amount),
              maxPriorityFeePerGas: null,
              maxFeePerGas: null,
            },
            (error, result) => {
              if (!error) {
              } else {
              }
            }
          )
          .on("receipt", function (receipt) {
            toast.success(<ToastMsg receipt={receipt} type="invest" />);
            fetchImportantData(Contract, web3Instance, account);
          });
      }
    } catch (error) {}
  };

  const insurance = async (amount) => {
    if (account) {
      await Contract.methods
        .setInsurance()
        .send(
          { from: account, value: web3Instance.utils.toWei(amount) },
          (error, result) => {
            if (!error) {
            }
          }
        )
        .on("receipt", function (receipt) {
          toast.success(<ToastMsg receipt={receipt} type="invest" />);
          fetchImportantData(Contract, web3Instance, account);
        });
    }
  };

  const withdraw = async () => {
    try {
      if (account) {
        await Contract.methods
          .withdraw()
          .send(
            {
              from: account,
              maxPriorityFeePerGas: null,
              maxFeePerGas: null,
            },
            (error, result) => {
              if (!error) {
              }
            }
          )
          .on("receipt", function (receipt) {
            toast.success(<ToastMsg receipt={receipt} type="withdrawn" />);
            fetchImportantData(Contract, web3Instance, account);
          });
      }
    } catch (error) {}
  };

  const ref_withdraw = async () => {
    try {
      if (account) {
        await Contract.methods
          .withdrawRef()
          .send(
            {
              from: account,
              maxPriorityFeePerGas: null,
              maxFeePerGas: null,
            },
            (error, result) => {
              if (!error) {
              }
            }
          )
          .on("receipt", function (receipt) {
            toast.success(<ToastMsg receipt={receipt} type="withdrawn" />);
            fetchImportantData(Contract, web3Instance, account);
          });
      }
    } catch (error) {}
  };

  const disconnectWallet = async () => {
    await web3Modal.clearCachedProvider();
    setAccount(null);
    localStorage.removeItem("WEB3_CONNECT_CACHED_PROVIDER");
    localStorage.removeItem("walletconnect");
    localStorage.removeItem("account");
    setProvider(null);
    setUserTransactions([]);
    clearInterval(interv);
  };

  const getHistoryInfo = async () => {
    try {
      if (Contract) {
        await Contract.methods
          .getUserTotalDeposits(account)
          .call(async (error, deposits) => {
            if (!error) {
              await Contract.methods
                .getUserTotalWithdrawn(account)
                .call((error, Withdrawn) => {
                  if (!error) {
                    setHistoryTotalInfo([
                      web3Instance.utils.fromWei(deposits),
                      web3Instance.utils.fromWei(Withdrawn),
                    ]);
                    if (userTransactions.length < 1) {
                      getUserTransactions();
                    }
                  }
                });
            }
          });
      }
    } catch (error) {}
  };

  const getUserTransactions = async (contract, account, web3) => {
    try {
      let userTxArray = [];
      if (contract && account) {
        await contract.methods
          .getUserActionLength(account)
          .call(async (error, count) => {
            if (!error) {
              setUserTransactions([]);
              for (let i = 1; count - i * 50 + 50 >= 0; i++) {
                await contract.methods
                  .getUserActions(account, i)
                  .call(async (error, actions) => {
                    if (!error) {
                      let actionsArray = Object.values(actions);
                      for (let i = 0; i < actionsArray[0].length; i++) {
                        userTxArray.push({
                          time: formatTimeStamp(actionsArray[2][i]),
                          action:
                            actionsArray[0][i] === "0" ? "Invest" : "Withdraw",
                          amount: numberWithCommas(
                            web3.utils.fromWei(actionsArray[1][i]),
                            5
                          ),
                        });
                      }
                    }
                  });
              }
              setUserTransactions(userTxArray.reverse());
            }
          });
      }
    } catch (error) {}
  };

  const openModal = async () => {};

  const context = {
    provider: provider,
    web3Instance: web3Instance,
    Contract: Contract,
    account: account,
    startTime: startTime,
    usdPrice: usdPrice,
    totalDeposit: totalDeposit,
    totalRefEarn: totalRefEarn,
    walletBalance: walletBalance,
    harvestValue: harvestValue,
    availableValue: availableValue,
    lastDepositValue: lastDepositValue,
    historyTotalInfo: historyTotalInfo,
    userTransactions: userTransactions,
    userInvitedInfo: userInvitedInfo,
    getInsuranceInfo: insuranceInfo,
    getAvailableRefInfo: availableRefInfo,
    userTotalDeposits: userTotalDeposits,
    handleDisconnectWallet: disconnectWallet,
    handleConnectToWallet: connectToWallet,
    handleInvest: invest,
    handleWithdraw: withdraw,
    refWithdraw: ref_withdraw,
    handleInsurance: insurance,
    openModal: openModal,
    handleGetHistoryInfo: getHistoryInfo,
  };
  return (
    <BlockchainContext.Provider value={context}>
      {props.children}
    </BlockchainContext.Provider>
  );
};

export default BlockchainContext;
